import React from 'react';
import {ButtonSize, ButtonType} from "./gd-button-ui5-new";

type Props = {
    className?      : string
    style?          : style

    onClick?        : callback
    label           : string
    type?           : ButtonType | 'primary' | 'normal' | 'secondary' | 'blue' | 'gray' | 'busy' | 'disabled'
    size?           : ButtonSize | 'small' | '30' | '24' | '26' | '28' | '32' | '36'
    icon?           : string

    iconPosition    : 'left' | 'right'
}

type State = {
    type        : undefined | ButtonType | 'primary' | 'normal' | 'secondary' | 'blue' | 'gray' | 'busy' | 'disabled'
}


// VERY DEPRICATED !!!!!
// use src/core/gd-components/buttons/gd-button/gd-button-ui5-new.tsx

export default class ButtonDeprecated extends React.Component<Props, State> {

    static defaultProps = {
        iconPosition: 'left'
    };

    constructor(props:Props) {
        super(props);

        this.state = {
            type: this.props.type
        };

    }

    componentDidUpdate(prevProps:Props, prevState:State) {
        if(prevProps.type !== this.props.type) {
            this.setState({
                // @ts-ignore
                type: this.props.type
            });
        }
    }

    setType(value:string) {
        if (['primary','normal','secondary','blue','gray','busy','disabled'].includes(value)) {
            this.setState({
                // @ts-ignore
                type: value
            });
        }
    }

    onClick = (e:React.SyntheticEvent) => {
        if (this.state.type === 'busy' || this.state.type === 'disabled') e.preventDefault();
        else if (this.props.onClick) this.props.onClick(e);
    }

    render() {

        const { type } = this.state;

        // console.log("render btn type=", this.props.type)

        const size = this.props.size || ButtonSize.STANDARD

        const classes = Classes('gd-btn', this.props.className, {
            'small':    size === 'small' || size === "30",
            'size-24':  size === '24',
            'size-26':  size === '26',
            'size-28':  size === '28',
            'size-32':  size === '32',
            'size-36':  size === '36',
            'primary':  type === 'primary',
            'secondary':  type === 'secondary',
            'blue':     type === 'blue',
            'gray':     type === 'gray',
            'busy':     type === 'busy',
            'disabled': type === 'disabled'
        });
        let buttonIcon = this.props.icon ? <span key="icon" className={Classes("btn-icon", this.props.icon, "position-"+this.props.iconPosition)}> </span> : null;
        let buttonLabel : any = this.props.label;

        if (type === 'busy') {
            buttonLabel = null;
            const btnSrc = gdConfig.assetsPath+"/skin/common/loader/btn-submit-busy.gif";
            buttonIcon = <img key="image" src={btnSrc} />
        }

        let content;
        switch(this.props.iconPosition) {
            case 'left': content = [buttonIcon, buttonLabel]; break;
            case 'right': content = [buttonLabel, buttonIcon]; break;
        }

        return (
            <div className={classes} onClick={this.onClick} style={this.props.style}>
                {content}
            </div>
        );
    }
};